import React, { useEffect, useState } from "react";
import BackHeader from "@components/header/BackHeader";
import styled from "@emotion/styled";
import { useTranslation } from "react-i18next";
import PushAlarmSwitch from "@pages/myPage/_component/PushAlarmSwitch";

const MenuWrapper = styled.div({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  padding: "4rem 2rem",
});

const ItemBox = styled.div(({ theme }) => ({
  width: "100%",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: "1.6rem",
  padding: "2rem 0",
  color: theme.color.black,
  fontSize: "1.6rem",
  lineHeight: "2rem",

  ".version": {
    color: theme.color.light_gray,
  },
}));

const Line = styled.div(({ theme }) => ({
  width: "100%",
  height: "1px",
  backgroundColor: theme.color.light_gray,
}));

const Descriptions = styled.div(({ theme }) => ({
  color: theme.color.light_gray,
  fontSize: "1.2rem",
}));

const SettingApp = () => {
  const { t } = useTranslation();
  const [androidVersion, setAndroidVersion] = useState<string>("0");
  const [iosVersion, setIosVersion] = useState<string>("0");
  const isAndroid = () => /Android/i.test(navigator.userAgent);

  useEffect(() => {
    if (window.android) {
      const androidVersion = window.android.getVersionName() || "";
      setAndroidVersion(androidVersion);
    }
  }, []);

  useEffect(() => {
    const getVersionName = async (event: any) => {
      setIosVersion(event.detail.data);
    };

    window.addEventListener("getVersionNameCallback", getVersionName);

    if (window.webkit) {
      window.webkit.messageHandlers.getVersionName.postMessage("");
    }

    return () =>
      window.removeEventListener("getVersionNameCallback", getVersionName);
  });

  return (
    <>
      <BackHeader title={"앱 설정"} />

      <MenuWrapper>
        <ItemBox>
          <span>{t("버전 정보")}</span>
          <span className="version">
            Ver {isAndroid() ? androidVersion : iosVersion}
          </span>
        </ItemBox>

        <Line />

        <ItemBox>
          <span>{t("푸시 알림")}</span>
          <PushAlarmSwitch />
        </ItemBox>

        <Descriptions>
          {t("판매 알림, 구매한 상품의 발송알림, 댓글 알림, 중요 정보알림")}
        </Descriptions>
      </MenuWrapper>
    </>
  );
};

export default SettingApp;
